import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';
import logo from "../Gallery/logo.png"

const Footer = () => {
    const navigate = useNavigate();

    const scrollToServices = () => {
        navigate('/');
        // Wait for home page to mount, then scroll to Services section
        setTimeout(() => {
            const el = document.getElementById('services');
            if (el) el.scrollIntoView({ behavior: 'smooth' });
        }, 300);
    };

    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-grid">
                    {/* Brand Column */}
                    <div className="footer-column brand-col">
                      <div className="footer-logo">
    <img src={logo} alt="Silver Sky Holidays Logo" className="footer-logo-img" />

    <div className="footer-logo-text">
        <span className="footer-logo-main">Silver Sky Holidays</span>
        <span className="footer-logo-tagline">RELATIONSHIP OF TRUST</span>
        <div className="footer-tagline-line"></div>
    </div>
</div>
                        <p className="brand-description">
                            Your trusted partner for unforgettable journeys. We specialize in crafting
                            luxury travel experiences and seamless visa solutions across the globe.
                        </p>
                        <div className="social-links">
                            <button><i className="fa-brands fa-facebook-f"></i></button>
                            <button><i className="fa-brands fa-instagram"></i></button>
                            <button><i className="fa-brands fa-x-twitter"></i></button>
                            <button><i className="fa-brands fa-linkedin-in"></i></button>
                        </div>
                    </div>

                    {/* Quick Links Column */}
                    <div className="footer-column">
                        <h4>Quick Links</h4>
                        <ul>
                            <li><button onClick={() => navigate('/')}>Home</button></li>
                            <li><button onClick={scrollToServices}>Our Services</button></li>
                            <li><button onClick={() => navigate('/packages')}>Holiday Packages</button></li>
                            <li><button onClick={() => navigate('/visa')}>Visa</button></li>
                            <li><button onClick={() => navigate('/flights')}>Flights</button></li>
                            <li><button onClick={() => navigate('/about')}>About Us</button></li>
                        </ul>
                    </div>

                    {/* Support Column */}
                    <div className="footer-column">
                        <h4>Support</h4>
                        <ul>
                            <li><button>Privacy Policy</button></li>
                            <li><button>Terms & Conditions</button></li>
                            <li><button>Customer Support</button></li>
                            <li><button>Refund Policy</button></li>
                            <li><button>Travel Insurance</button></li>
                        </ul>
                    </div>

                    {/* Contact Column */}
                    <div className="footer-column contact-col">
                        <h4>Get In Touch</h4>
                        <div className="contact-info">
                            <div className="contact-item">
                                <i className="fa-solid fa-location-dot"></i>
                                <p>B/702 Spectra , B/H TRP Mall Central Bopal Ahmedabad : 380058</p>
                            </div>
                            <div className="contact-item">
                                
                                <i className="fa-solid fa-phone"></i>
                                <p>+91 99250 48452</p>
                                 <i className="fa-solid fa-phone"></i>
                                <p>+91 95863 76010</p>
                                
                            </div>
                            <div className="contact-item">
                                <i className="fa-solid fa-envelope"></i>
                                <p>sanjay@silverskyholidays.in</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Newsletter Section */}
                {/* <div className="footer-newsletter">
                    <div className="newsletter-text">
                        <h3>Subscribe to our Newsletter</h3>
                        <p>Get the latest travel deals and destination inspiration.</p>
                    </div>
                    <form className="newsletter-form" onSubmit={(e) => e.preventDefault()}>
                        <input type="email" placeholder="Enter your email" required />
                        <button type="submit">Subscribe</button>
                    </form>
                </div> */}

                {/* Bottom Bar */}
                <div className="footer-bottom">
                    <p>&copy; 2026 Silver Sky Holidays. All Rights Reserved.</p>
                    <div className="payment-icons">
                        <i className="fa-brands fa-cc-visa"></i>
                        <i className="fa-brands fa-cc-mastercard"></i>
                        <i className="fa-brands fa-cc-apple-pay"></i>
                        <i className="fa-brands fa-google-pay"></i>
                    </div>
                </div>
                <div className="footer-designer">
                    <p>Designed by{' '}<a href="https://github.com/gk1503" target="_blank" rel="noopener noreferrer">GopalKrishnan</a></p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
